import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { useLangFile } from 'js/context/LanguageContext';

export interface MergeFieldInputs {
  fieldName: string;
  fieldNumber: string;
}

interface MergeFieldInputDialogProps {
  open: boolean;
  inputs: MergeFieldInputs;
  onChange: (key: keyof MergeFieldInputs, value: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const MergeFieldsInputDialog: React.FC<MergeFieldInputs> = ({
  open,
  inputs,
  onChange,
  onClose,
  onConfirm,
}) => {
  const LangFile = useLangFile();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{LangFile.MergeFieldsInputDialog.title}</DialogTitle>
      <DialogContent>
        <TextField
          label={LangFile.MergeFieldsInputDialog.fieldName}
          fullWidth
          value={inputs.fieldName}
          onChange={(e) => onChange('fieldName', e.target.value)}
        />
        <TextField
          style={{ marginTop: '8px' }}
          label={LangFile.MergeFieldsInputDialog.fieldNumber}
          fullWidth
          value={inputs.fieldNumber}
          onChange={(e) => onChange('fieldNumber', e.target.value)}
          error={!inputs.fieldNumber?.trim()}
        />
        <Box
          sx={{
            minHeight: '20px',
          }}
        >
          {!inputs.fieldNumber?.trim() && (
            <Typography color="error" variant="caption">
              {LangFile.MergeFieldsInputDialog.fieldNumberRequired}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{LangFile.MergeFieldsInputDialog.cancel}</Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          color={'primary'}
          disabled={!inputs.fieldNumber?.trim()}
        >
          {LangFile.MergeFieldsInputDialog.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MergeFieldsInputDialog;
